import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, Router, CanActivateFn } from "@angular/router";
import { AuthService } from "../auth";

export const dashboardManagementGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    const canActivateValidation = (route: ActivatedRouteSnapshot) => {
        return authService.hasSecurityLevel(route.data.expectedRole);
    };

    if (canActivateValidation(route)) {
        return true;
    } else {
        return router.createUrlTree(["/unauthorizedroute"]);
    }
};
